import React from "react";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { PlatformContext } from "../components/Platform/PlatformContext";

const Terms: React.FC = () => {
  let navigate = useNavigate();
  let platform = useContext(PlatformContext);
  const isMobile = !platform?.isDesktop;

  return (
    <div className="flex flex-col w-screen items-center justify-center">
      <h1 className="text-3xl font-bold text-white mt-10">Allgemeine Geschäftsbedingungen</h1>

      <div className="bg-white bg-opacity-10 backdrop-blur-lg rounded-lg p-6 m-6 max-w-3xl text-white shadow-lg border border-white/20">
        
        {/* 1. Geltungsbereich */}
        <div className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">1. Geltungsbereich</h2>
          <p>
            Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für die Nutzung unserer Plattform zur Verwaltung der Faculties Football League (FFL). Wir vermitteln ausschließlich zwischen den Teams und stellen keine eigenen Ressourcen bereit.
          </p>
        </div>

        {/* 2. Registrierung */}
        <div className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">2. Registrierung</h2>
          <p>
            Nutzer müssen sich mit einer gültigen E-Mail-Adresse registrieren. Die Angabe von Name und Profilbild ist optional und muss nicht die echte Identität widerspiegeln. Jedes Team benennt einen Kapitän, der für die Kommunikation verantwortlich ist.
          </p>
        </div>

        {/* 3. Nutzung der Plattform */}
        <div className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">3. Nutzung der Plattform</h2>
          <p>
            Die Plattform dient der Organisation und Koordination von Spielen zwischen den Teams. Wir stellen keine Spielplätze, Ausrüstung oder sonstige Ressourcen zur Verfügung. Die gesamte Organisation, einschließlich Spielort, Zeitplan und Durchführung, liegt in der Eigenverantwortung der Teams.
          </p>
        </div>

        {/* 4. Haftung */}
        <div className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">4. Haftung</h2>
          <p>
            Wir übernehmen keine Haftung für Verletzungen, Sachschäden oder sonstige Schäden, die im Zusammenhang mit den Spielen entstehen. Ebenso haften wir nicht für technische Ausfälle, Datenverluste oder Streitigkeiten zwischen Teams, soweit gesetzlich zulässig. Die Teilnahme an der Liga erfolgt auf eigenes Risiko der Teams und Spieler.
          </p>
        </div>

        {/* 5. Vermittlung */}
        <div className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">5. Vermittlung</h2>
          <p>
            Unsere Rolle beschränkt sich auf die Bereitstellung der Plattform zur Vermittlung zwischen den Teams. Wir sind nicht Veranstalter der Spiele und greifen nicht in die Organisation oder Durchführung ein. Alle Vereinbarungen zwischen den Teams (z. B. Spieltermine, Regeln) liegen in deren eigener Verantwortung.
          </p>
        </div>

        {/* 6. Kündigung */}
        <div className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">6. Kündigung</h2>
          <p>
            Nutzer können ihr Konto jederzeit kündigen, indem sie die Kündigung in ihrem Profil anfordern. Nach Kündigung werden die Daten gemäß unserer Datenschutzerklärung gelöscht.
          </p>
        </div>

        {/* 7. Änderungen der AGB */}
        <div className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">7. Änderungen der AGB</h2>
          <p>
            Wir behalten uns das Recht vor, diese AGB jederzeit zu ändern. Nutzer werden über Änderungen per E-Mail oder auf der Plattform informiert. Mit der weiteren Nutzung der Plattform gelten die neuen AGB als akzeptiert.
          </p>
        </div>

      </div>
    </div>
  );
};

export default Terms;